module.exports = __webpack_public_path__ + "static/media/logo.b5a121d1.png";